import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	title: {
		id: 'eoc-schedule.ui.list.take-on-call.title',
		defaultMessage: 'Take on-call',
		description: 'Title for take on-call modal.',
	},
	explanation: {
		id: 'eoc-schedule.ui.list.take-on-call.explanation',
		defaultMessage:
			"You're overriding all rotations and you'll be the only on-call participant on this schedule for <bold>one hour</bold>.",
		description: 'Explanation for take on-call usage.',
	},
});

export { messages };
